var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashiconsAdminPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22.5V3H24V22.5H9ZM7.5 24H19.5V27H4.5V7.5H7.5V24Z",
    fill: "#8BAEC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashiconsAdminPage);
export default __webpack_public_path__ + "static/media/dashicons-admin-page.fd4de0b7bee45b4800fbeb490d29b05e.svg";
export { ForwardRef as ReactComponent };